<template>
	<div class="bigbox cursorstyle">
		<!-- <div class="bannder">
		</div> -->

		<p class="title">关于我院最新的医药专利审核标准及考核等级规格说明</p>
		<!-- 表单 -->
		<div class="tablebox">
			<div class="textbox">
				<h1
					style=" margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">注册</span>
				</h1>
				<p style="margin-top:14pt; margin-bottom:14pt; font-size:14pt"><span style="font-family:'等线'">1)
					</span><span style="font-family:'宋体'; font-size:12pt; font-weight:bold">功能描述</span><span
						style="font-family:'宋体'; font-size:12pt; font-weight:bold">：</span><span
						style="font-family:Calibri; font-size:12pt">T</span><span
						style="font-family:Calibri; font-size:12pt">ab</span><span
						style="font-family:'宋体'; font-size:12pt">分为个人、党政机关事业单位、企业三种类型注册，</span><span
						style="font-family:'宋体'; font-size:12pt">用户输入注册所需要的信息，提交注册信息，系统验证提交的注册信息，通过则保存用户注册信息。管理员后台审核并授权后，成为授权用户。同时系统自动通过</span><span
						style="font-family:'宋体'; font-size:12pt">邮箱</span><span
						style="font-family:'宋体'; font-size:12pt">通知用户。</span><span
						style="font-family:'宋体'; font-size:12pt">
					</span></p>
				<p style="margin-top:14pt; margin-bottom:14pt; font-size:12pt"><span style="font-family:'等线'">2)
					</span><span style="font-family:'宋体'; font-weight:bold">输入输出</span><span
						style="font-family:'仿宋'; font-weight:bold">:</span><span style="font-family:'宋体'">输入</span><span
						style="font-family:'仿宋'">:</span><span style="font-family:'宋体'">用户注册需要填写的信息，包括</span><span
						style="font-family:'宋体'">手机号</span><span style="font-family:'宋体'">、邮箱地址</span><span
						style="font-family:'宋体'">等</span><span style="font-family:'宋体'; color:#ff0000">（待澄清）</span><span
						style="font-family:'宋体'">。其中</span><span style="font-family:'宋体'">手机号</span><span
						style="font-family:'宋体'">要求输入</span><span style="font-family:'宋体'"> </span><span
						style="font-family:'等线'">11</span><span style="font-family:'宋体'">位数字</span><span
						style="font-family:'宋体'">。</span><span style="font-family:'宋体'"> </span><span
						style="font-family:'宋体'">输出</span><span style="font-family:'仿宋'">:</span><span
						style="font-family:'宋体'">注册信息有效，点击</span><span style="font-family:'仿宋'">“</span><span
						style="font-family:'宋体'">注册</span><span style="font-family:'仿宋'">”</span><span
						style="font-family:'宋体'">按钮，系统弹出提示信息，经用户确认后，自动跳转到首页。提示信息为</span><span
						style="font-family:'仿宋'">:</span>
				</p>
				<p style="margin-top:14pt; margin-bottom:14pt; font-size:12pt"><span
						style="font-family:'宋体'; color:#0000ff">注册成功</span><span
						style="font-family:'宋体'; color:#0000ff">
					</span></p>
				<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
						style="font-family:'宋体'; color:#0000ff">
					</span><span style="font-family:'宋体'; color:#0000ff">我们将在审核通过后向您</span><span
						style="font-family:'宋体'; color:#0000ff">邮箱</span><span
						style="font-family:'宋体'; color:#0000ff">发送确认</span><span
						style="font-family:'宋体'; color:#0000ff">信息</span><span
						style="font-family:'宋体'; color:#0000ff">，请注意查收。</span></p>
				<p style="margin-top:14pt; margin-bottom:14pt; font-size:14pt"><span
						style="font-family:'宋体'; font-size:12pt">注册信息未输入或输入无效时，系统在相应的输入框下用红字提示用户正确输入。</span><span
						style="font-family:'宋体'"> </span></p>
				<table cellspacing="0" cellpadding="0" style="border-collapse:collapse">
					<tr>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#d6d6d6">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'">注册信息未输入或输入无效</span></p>
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'">&#xa0;</span></p>
						</td>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#d6d6d6">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'">提示信息</span><span style="font-family:'宋体'"> </span></p>
						</td>
					</tr>
					<tr>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#ffffff">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'">手机号</span><span style="font-family:'宋体'">未输入</span><span
									style="font-family:'宋体'"> </span></p>
						</td>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#ffffff">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'; color:#0000ff">请填写</span><span
									style="font-family:'宋体'; color:#0000ff">手机号</span><span
									style="font-family:'宋体'; color:#0000ff"> </span></p>
						</td>
					</tr>
					<tr>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#ffffff">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'">系统中已存在的</span><span
									style="font-family:'宋体'">手机号</span><span style="font-family:'宋体'"> </span></p>
						</td>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#ffffff">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'; color:#0000ff">已经注册的</span><span
									style="font-family:'宋体'; color:#0000ff">手机号，请直接登录</span><span
									style="font-family:'宋体'; color:#0000ff"> </span></p>
						</td>
					</tr>
					<tr>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#ffffff">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'">未勾选用户使用协议和隐私协</span><span style="font-family:'宋体'">
								</span><span style="font-family:'宋体'">议</span><span style="font-family:'宋体'"> </span>
							</p>
						</td>
						<td
							style="border-style:solid; border-width:0.75pt; padding:0.38pt; vertical-align:middle; background-color:#ffffff">
							<p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt"><span
									style="font-family:'宋体'; color:#0000ff">勾选同意用户使用协议和隐私</span><span
									style="font-family:'宋体'; color:#0000ff"> </span><span
									style="font-family:'宋体'; color:#0000ff">协议，才能继续注册</span><span
									style="font-family:'宋体'; color:#0000ff"> </span></p>
						</td>
					</tr>
				</table>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">首页</span>
				</h1>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:'宋体'">工作台</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span
						style="font-family:'宋体'">首页，是各二级频道的信息聚合页，根据规则展示部分二级频道的内容，用户想更深入了解，可以通过聚合页的相关内容，跳转到二级频道页。首页的主要功能有：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">1．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">入口：</span><span
						style="font-family:'宋体'">登录入口，注册入口，商标</span><span style="font-family:'宋体'">知识产权</span><span
						style="font-family:'宋体'">申请</span><span style="font-family:'宋体'">入口，</span><span
						style="font-family:'宋体'">专利知识产权申请入口，著作权申请入口，二级频道导航入口（除主导航入口外还有关于我们等子栏目）</span><span
						style="font-family:'宋体'">。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">2．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">关键内容展示：</span><span
						style="font-family:'宋体'">包括</span><span style="font-family:'宋体'">申请流程介绍，平台宣传语，宣传图；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">3．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">统计信息：</span><span
						style="font-family:'宋体'">为了</span><span
						style="font-family:'宋体'">显示网站的互动型、办事的透明性以及权威性显示累计知识产权申请数量，分别显示商标，著作及专利的累积收录数量。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">4．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">通知公告：</span><span
						style="font-family:'宋体'">默认展示最新的5条通知公告，列包括标题和发布时间，根据时间倒序排序，后台可设置置顶功能，根据置顶的权重优先排序。默认显示第一条通知公告的图片封面。点击更多可跳转到通知公告列表页。点击标题进入通知公告内容详情页。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">5．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">相关规范：</span><span
						style="font-family:'宋体'">默认展示最新的5条相关规范内容，列包括标题和发布时间，根据时间倒序排序，后台可设置置顶功能，根据置顶的权重优先排序。点击更多可跳转到相关规范列表页。点击标题进入相关规范内容详情页。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">6．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">常用表格：</span><span
						style="font-family:'宋体'">默认展示最新的5条常用表格，列包括标题和操作，根据时间倒序排序，后台可设置置顶功能，根据置顶的权重优先排序。点击更多可跳转到常用表格列表页。点击下载或标题，提示将内容下载到本机。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">7．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'"> </span><span style="font-family:'宋体'"> </span><span
						style="font-family:'宋体'">点击“北京中医医院商标注册-去申请”，如果已登录则跳转至“北京中医医院商标注册”申请页面。未登录提示先登录。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">8．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'"> </span><span style="font-family:'宋体'"> </span><span
						style="font-family:'宋体'">点击“北京中医医院软件著作权-去申请”，</span><span style="font-family:'宋体'"> </span><span
						style="font-family:'宋体'">如果已登录则跳转至“北京中医医院软件著作权”申请页面。未登录提示先登录。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">9．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'"> 点击“北京中医医院专利申报-去申请”，</span><span style="font-family:'宋体'"> </span><span
						style="font-family:'宋体'">如果已登录则跳转至“北京中医医院专利申报”申请页面，点击“添加”按钮，进行添加，区分个人与法人或其他组织。未登录提示先登录。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">10．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;
					</span><span
						style="font-family:'宋体'">顶部可以根据输入的内容对通知公告、相关规范、常用表格进行检索，精准匹配，如有匹配结果，直接显示相关信息，如果没有匹配结果，显示未检索到相关信息的默认页。</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">申请管理</span>
				</h1>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">用户登录后可以进入“</span><span
						style="font-family:'宋体'; font-weight:bold">申请管理</span><span
						style="font-family:'宋体'">”页，登录入口默认在平台右上角，登录后显示个人中心链接和退出登录链接。个人中心主要功能为：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">1．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">申请流程说明：</span><span
						style="font-family:'宋体'">默认</span><span
						style="font-family:'宋体'">显示申请流程图，点击不同的流程节点进入该节点的详情页。申请流程包括前期咨询，表格下载，资料上传，材料初审，驳回，材料复审，材料上报，领取证书。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">2．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">我的专利：</span><span style="font-family:'宋体'"> </span>
				</p>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:48pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">查询</span><span
						style="font-family:'宋体'; font-weight:bold">：</span><span
						style="font-family:'宋体'">包括已申请的知识产权名称，申请状态，申请方式、申请时间。</span>
				</p>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:48pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">添加：</span><span
						style="font-family:'宋体'">根据登录账号的用户种类不同，添加的页面字段显示不一样。</span>
				</p>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:48pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">个人申请：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">法人或其他组织名义申请：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">专利录入：</span><span
						style="font-family:'宋体'">自主录入</span><span style="font-family:'宋体'">主要是</span><span
						style="font-family:'宋体'">为方便大众用户快速上传曾经已获取授权发证的专利在本平台进行知识产权保护，验证专利信息是否真实。</span><span
						style="font-family:'宋体'">手动录入已授权的专利信息，根据字段输入相关信息，进行申请录入流程</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">列表：</span><span
						style="font-family:'宋体'">默认显示</span><span
						style="font-family:'宋体'">5条我申请的专利，列包括标题、申请方式、申请时间和申请状态，根据时间倒序排序；点击标题进入申请详情页。申请状态包括审核中，被驳回，补充材料，</span><span
						style="font-family:'宋体'">录入授权</span><span style="font-family:'宋体'">，已授权，五种状态。已通过标亮显示。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">默认</span><span style="font-family:Calibri">5</span><span
						style="font-family:'宋体'">条，</span><span style="font-family:'宋体'">超过</span><span
						style="font-family:Calibri">5</span><span style="font-family:'宋体'">条可进行</span><span
						style="font-family:'宋体'">翻页，也可直接跳转首页</span><span style="font-family:'宋体'">、某一页</span><span
						style="font-family:'宋体'">或末页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">3．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">我的商标：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">查询</span><span
						style="font-family:'宋体'; font-weight:bold">：</span><span
						style="font-family:'宋体'">包括已申请的知识产权名称，申请状态，申请方式、申请时间。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">添加：</span><span
						style="font-family:'宋体'">根据登录账号的用户种类不同，添加的页面字段显示不一样。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">个人申请：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">法人或其他组织名义申请：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">专利录入：</span><span
						style="font-family:'宋体'">自主录入</span><span style="font-family:'宋体'">主要是</span><span
						style="font-family:'宋体'">为方便大众用户快速上传曾经已获取授权发证的专利在本平台进行知识产权保护，验证专利信息是否真实。</span><span
						style="font-family:'宋体'">手动录入已授权的商标信息，根据字段输入相关信息，进行申请录入流程</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">列表：</span><span
						style="font-family:'宋体'">默认显示</span><span
						style="font-family:'宋体'">5条我申请的商标，列包括标题、申请时间和申请状态，根据时间倒序排序；点击标题进入申请详情页。申请状态包括审核中，被驳回，补充材料，</span><span
						style="font-family:'宋体'">录入授权</span><span style="font-family:'宋体'">，已授权，五种状态。已通过标亮显示。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">默认</span><span style="font-family:Calibri">5</span><span
						style="font-family:'宋体'">条，</span><span style="font-family:'宋体'">超过</span><span
						style="font-family:Calibri">5</span><span style="font-family:'宋体'">条可进行</span><span
						style="font-family:'宋体'">翻页，也可直接跳转首页</span><span style="font-family:'宋体'">、某一页</span><span
						style="font-family:'宋体'">或末页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">我的著作：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">查询</span><span
						style="font-family:'宋体'; font-weight:bold">：</span><span
						style="font-family:'宋体'">包括已申请的知识产权名称，申请状态，申请方式、申请时间。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">添加：</span><span
						style="font-family:'宋体'">根据登录账号的用户种类不同，添加的页面字段显示不一样。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">个人申请：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">法人或其他组织名义申请：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:24pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">专利录入：</span><span
						style="font-family:'宋体'">自主录入</span><span style="font-family:'宋体'">主要是</span><span
						style="font-family:'宋体'">为方便大众用户快速上传曾经已获取授权发证的专利在本平台进行知识产权保护，验证专利信息是否真实。</span><span
						style="font-family:'宋体'">手动录入已授权的软著信息，根据字段输入相关信息，进行申请录入流程</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">列表：</span><span
						style="font-family:'宋体'">默认显示</span><span
						style="font-family:'宋体'">5条我申请的著作，列包括标题、申请方式、申请时间和申请状态，根据时间倒序排序；点击标题进入申请详情页。申请状态包括审核中，被驳回，补充材料，</span><span
						style="font-family:'宋体'">录入授权</span><span style="font-family:'宋体'">，已授权，五种状态。已通过标亮显示。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:45pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">默认</span><span style="font-family:Calibri">5</span><span
						style="font-family:'宋体'">条，</span><span style="font-family:'宋体'">超过</span><span
						style="font-family:Calibri">5</span><span style="font-family:'宋体'">条可进行</span><span
						style="font-family:'宋体'">翻页，也可直接跳转首页</span><span style="font-family:'宋体'">、某一页</span><span
						style="font-family:'宋体'">或末页；</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">成果转化</span>
				</h1>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:26.25pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:'宋体'">授权</span><span
						style="font-family:'宋体'">转化的知识产权进行公开招标，显示招标信息及知识产权相关信息，线下电话报名。页面顶部显示报名电话，列表数据显示为后台控制，主要功能包括：</span>
				</p>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-indent:26.25pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:'宋体'">&#xa0;</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">1．</span><span style="font:7pt 'Times New Roman'">&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">转化公告：</span><span
						style="font-family:'宋体'; font-size:10.5pt">显示最近</span><span
						style="font-family:'宋体'; font-size:10.5pt">10</span><span
						style="font-family:'宋体'; font-size:10.5pt">条转化公告，点击公告标题，</span><span
						style="font-family:'宋体'">页面跳转至公告详情页面；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">点击“更多”，页面跳转至公告列表页面，</span><span
						style="font-family:'宋体'">默认显示</span><span style="font-family:'Times New Roman'">2</span><span
						style="font-family:'Times New Roman'">0</span><span style="font-family:'宋体'">条，点击</span><span
						style="font-family:'宋体'">公告标题，页面跳转至公告详情页面。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">2</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">成果转化</span><span
						style="font-family:'宋体'; font-weight:bold">列表</span><span style="font-family:'宋体'">：</span><span
						style="font-family:'宋体'">默认显示</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0</span><span style="font-family:'宋体'">条，列名包括标题，发布时间</span><span
						style="font-family:'宋体'">，以发布时间倒序排序，后台可置顶，根据置顶的权重进行优先排序。点击标题进入公告详情页。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">3</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">可以自定义显示条数，默认</span><span style="font-family:Calibri">20</span><span
						style="font-family:'宋体'">条，可选择</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0/50/100</span><span
						style="font-family:'宋体'">条，前后一页翻页，也可直接跳转首页或末页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">4</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">面包屑导航：</span><span
						style="font-family:'宋体'">显示内容浏览的层级，本频道显示顺序为首页</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">成果转化</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">成果转化</span><span
						style="font-family:'宋体'">标题，点击不同的层级可跳转到不同页；</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'; font-weight:bold">成果转化</span><span
						style="font-family:'宋体'; font-weight:bold">详情：</span><span
						style="font-family:'宋体'">点击标题显示通知</span><span style="font-family:'宋体'">成果转化</span><span
						style="font-family:'宋体'">详情页，可以展示图文信息，默认图片最下方展示，显示发布时间，发布人，浏览次数，标题，</span><span
						style="font-family:'宋体'">成果转化</span><span style="font-family:'宋体'">内容</span><span
						style="font-family:'宋体'">详情</span><span style="font-family:'宋体'">。</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">办事指南</span>
				</h1>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">“</span><span style="font-family:'宋体'">通知公告</span><span
						style="font-family:'宋体'">”</span><span
						style="font-family:'宋体'">用来发布最新的平台政策和相关变化信息，能够及时的通知到申请者，最近应该注意的事项，例如暂停申请，或者申请需要增加材料等内容。通知公告为二级频道，通过首页或导航进入。主要功能包括：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">1</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">通知公告列表</span><span
						style="font-family:'宋体'">，默认显示</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0</span><span
						style="font-family:'宋体'">条，列名包括标题，发布时间，浏览次数，以发布时间倒序排序，后台可置顶，根据置顶的权重进行优先排序。点击标题进入公告详情页。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">2</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">可以自定义显示条数，默认</span><span style="font-family:Calibri">20</span><span
						style="font-family:'宋体'">条，可选择</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0/50/100</span><span
						style="font-family:'宋体'">条，前后一页翻页，也可直接跳转首页或末页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">3</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">面包屑导航：</span><span
						style="font-family:'宋体'">显示内容浏览的层级，本频道显示顺序为首页</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">通知公告</span><span
						style="font-family:Calibri">&gt;</span><span
						style="font-family:'宋体'">公告标题，点击不同的层级可跳转到不同页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">4</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">公告详情：</span><span
						style="font-family:'宋体'">点击标题显示通知公告详情页，可以展示图文信息，默认图片最下方展示，显示发布时间，发布人，浏览次数，标题，公告内容。</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">通知公告</span>
				</h1>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">“办事指南”</span><span style="font-family:'宋体'">用来发布</span><span
						style="font-family:'宋体'">知识产权申请相关的知识</span><span style="font-family:'宋体'">，</span><span
						style="font-family:'宋体'">类似</span><span style="font-family:Calibri">FAQ</span><span
						style="font-family:'宋体'">，后期可根据此内容实现智能客服，智能问答机器人等相关功能，前期主要以问答的形式发布申请者可能会问到的问题。办事指南</span><span
						style="font-family:'宋体'">为二级频道，通过首页或导航进入。主要功能包括：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'Times New Roman'">1</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">办事指南列表</span><span
						style="font-family:'宋体'">：</span><span style="font-family:'宋体'">单页显示知识产权申请的办事指南</span><span
						style="font-family:'宋体'; font-weight:bold">。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'Times New Roman'">2</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">面包屑导航：</span><span
						style="font-family:'宋体'">显示内容浏览的层级，本频道显示顺序为首页</span><span
						style="font-family:'Times New Roman'">&gt;</span><span style="font-family:'宋体'">办事指南</span><span
						style="font-family:'Times New Roman'">&gt;</span><span
						style="font-family:'宋体'">问题，点击不同的层级可跳转到不同页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'Times New Roman'">3</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">指南详情：</span><span
						style="font-family:'宋体'">点击标题显示办事指南详情页，可以展示图文信息，默认图片最下方展示，显示发布时间，发布人，浏览次数，标题，公告内容。</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">相关规范</span>
				</h1>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">“相关规范”</span><span style="font-family:'宋体'">用来发布</span><span
						style="font-family:'宋体'">知识产权申请相关的国家规范</span><span style="font-family:'宋体'">，</span><span
						style="font-family:'宋体'">包括审核机制，注销，复审等规范，使用规范等信息。相关规范</span><span
						style="font-family:'宋体'">为二级频道，通过首页或导航进入。主要功能包括：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">1</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">相关</span><span
						style="font-family:'宋体'; font-weight:bold">规范</span><span
						style="font-family:'宋体'; font-weight:bold">列表</span><span
						style="font-family:'宋体'">，默认显示</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0</span><span
						style="font-family:'宋体'">条，列名包括标题，发布时间，浏览次数，以发布时间倒序排序，后台可置顶，根据置顶的权重进行优先排序。点击标题进入</span><span
						style="font-family:'宋体'">规范</span><span style="font-family:'宋体'">详情页。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">2</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">可以自定义显示条数，默认</span><span style="font-family:Calibri">20</span><span
						style="font-family:'宋体'">条，可选择</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0/50/100</span><span
						style="font-family:'宋体'">条，前后一页翻页，也可直接跳转首页或末页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">3</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">面包屑导航：</span><span
						style="font-family:'宋体'">显示内容浏览的层级，本频道显示顺序为首页</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">相关规范</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">标题，点击不同的层级可跳转到不同页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">4</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">规范</span><span
						style="font-family:'宋体'; font-weight:bold">详情：</span><span
						style="font-family:'宋体'">点击标题显示</span><span style="font-family:'宋体'">规范</span><span
						style="font-family:'宋体'">详情页，可以展示图文信息，默认图片最下方展示，显示发布时间，发布人，浏览次数，标题，公告内容。</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
				<h1
					style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify; page-break-inside:avoid; page-break-after:avoid; line-height:241%; widows:0; orphans:0; font-size:22pt">
					<span style="font-family:'宋体'">常用表格</span>
				</h1>
				<p
					style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:'宋体'">“常用表格”</span><span style="font-family:'宋体'">用来发布</span><span
						style="font-family:'宋体'">知识产权申请相关的常用表格，申请者可以直接下载到本地，完成线下流程申请和资料填报。常用表格</span><span
						style="font-family:'宋体'">为二级频道，通过首页或导航进入。主要功能包括：</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">1</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">常用表格</span><span
						style="font-family:'宋体'; font-weight:bold">列表</span><span
						style="font-family:'宋体'">，默认显示</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0</span><span style="font-family:'宋体'">条，列名包括标题，发布时间，</span><span
						style="font-family:'宋体'">操作，</span><span
						style="font-family:'宋体'">以发布时间倒序排序，后台可置顶，根据置顶的权重进行优先排序。点击</span><span
						style="font-family:'宋体'">标题或者下载按钮可将文件下载到本地</span><span style="font-family:'宋体'">。</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">2</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">翻页：</span><span
						style="font-family:'宋体'">可以自定义显示条数，默认</span><span style="font-family:Calibri">20</span><span
						style="font-family:'宋体'">条，可选择</span><span style="font-family:Calibri">2</span><span
						style="font-family:Calibri">0/50/100</span><span
						style="font-family:'宋体'">条，前后一页翻页，也可直接跳转首页或末页；</span>
				</p>
				<p
					style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
					<span style="font-family:Calibri">3</span><span style="font-family:'宋体'">．</span><span
						style="font:7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
						style="font-family:'宋体'; font-weight:bold">面包屑导航：</span><span
						style="font-family:'宋体'">显示内容浏览的层级，本频道显示顺序为首页</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">常用表格</span><span
						style="font-family:Calibri">&gt;</span><span style="font-family:'宋体'">标题，点击不同的层级可跳转到不同页；</span>
				</p>
				<p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
					<span style="font-family:Calibri">&#xa0;</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 类型
			ProfessionalType: [{
				value: '选项1',
				label: '全部'
			}, {
				value: '选项2',
				label: '发明专利'
			}, {
				value: '选项3',
				label: '实用新型专利'
			}, {
				value: '选项4',
				label: '外观设计专利'
			}],
			ProfessionalTypeValue: '选项1',
			// 创建方式
			CreationMethod: [{
				value: '选项1',
				label: '全部'
			}, {
				value: '选项2',
				label: '信息录入'
			}, {
				value: '选项3',
				label: '专利申请'
			}],
			CreationMethodValue: '选项1',
			// 申请状态
			ApplicationStatus: [{
				value: '选项1',
				label: '全部'
			}, {
				value: '选项2',
				label: '审核中'
			}, {
				value: '选项3',
				label: '被驳回'
			}, {
				value: '选项4',
				label: '补充材料'
			}, {
				value: '选项5',
				label: '国家知识产权平台审核'
			}, {
				value: '选项6',
				label: '已授权'
			}],
			ApplicationStatusValue: '选项1',
			// 提交时间
			value1time: '',
			// 授权时间
			value2time: '',
			// 表单
			tableData: [{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},
			{
				date: '关于我院最新的医药专利审核标准及考核等级规格说明',
				name: '22',
				address6: '2021.08.11',
			},

			],
			// 分页
			currentPage4: 4,
		}
	},
	mounted() {

	},
	methods: {
		Noticebtn() {
			this.$router.push('./NoticeDetails')
		},
	}
}
</script>

<style scoped="scoped" lang="less">
.bigbox {
	width: 63vw;
	margin: 0 auto;
	// border: 1px red solid;
}

.bannder {
	width: 100%;
	height: 326px;
	background: #D8D8D8;
	margin: 0 auto;
	margin-top: 14px;
}

.nav {
	margin-top: 14px;
	font-size: 16px;
	color: #333333;
}

.title {
	font-size: 18px;
	font-weight: bold;
	color: #333333;
	margin-top: 10px;
}

.tablebox {
	height: auto;
	background: #FFFFFF;
	box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.07);
	margin-top: 20px;
	overflow: hidden;

	p {
		font-weight: 400;
		//color: #DF3E3E;
		font-size: 36px;
		text-align: center;
		margin-top: 59px;
	}

	.textbox {
		width: 96%;
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		margin: 0 auto;
		margin-top: 53px;
	}
}
</style>
